module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_TOC_Heading",
    attrs: {
      "id": "tableofcontents"
    }
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0001#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Book Description")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0002#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0004#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0004#auto_bookmark_table_of_contents_2"
    }
  }, [_vm._v("Cloning Mammoths")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Mammoth Dawn")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_table_of_contents_2"
    }
  }, [_vm._v("The Original Novella")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Mammoth Dawn")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_2"
    }
  }, [_vm._v("Full Novel Treatment and Proposal")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_3"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_3"
    }
  }, [_vm._v("Overview")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_4"
    }
  }, [_vm._v("Scientific Basis—Why Mammoths? Why Now?")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_3"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_5"
    }
  }, [_vm._v("Prologue—The Hunt")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_3"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_6"
    }
  }, [_vm._v("Part I—Mammoth Ranch")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_7"
    }
  }, [_vm._v("Part II—The Resurrection Preserve")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_8"
    }
  }, [_vm._v("Part III—Survival of the Fittest")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_9"
    }
  }, [_vm._v("Part IV—Pleistocene Rules")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_10"
    }
  }, [_vm._v("Bringing Back the Mammoths")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_3"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_11"
    }
  }, [_vm._v("Why?")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_3"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_12"
    }
  }, [_vm._v("How?")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_3"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_table_of_contents_13"
    }
  }, [_vm._v("When?")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0007#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("About the Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0008#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("If You Liked …")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0009#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Other WordFire Press Titles")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67875b40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0003.vue
// module id = 66
// module chunks = 0